import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Box, Stack, Paper, Checkbox, Modal } from "@mui/material";
import TkButton from "../../../components/atoms/TkButton";
import Typography from "@mui/material/Typography";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./_style.scss";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

/**
 * 重要事項確認モーダル画面
 * SCRC030102固有部品
 * @param {boolean} isRegister 同意フラグ
 * @param {boolean} confirmed 親画面のAPIから「重要事項確認日」を受け取ったかどうかのフラグ
 * @return TkImportantMattersModal 重要事項確認モーダル画面
 */
export const TkImportantMattersModal: React.FC<
  TkImportantMattersModalProps
> = ({ isRegister, confirmed }) => {
  const [open, setOpen] = useState(false);
  const [checkOne, setCheckOne] = useState(false);
  const [checkTwo, setCheckTwo] = useState(false);
  const [checkThree, setCheckThree] = useState(false);
  const [checkFour, setCheckFour] = useState(false);
  const [checkFive, setCheckFive] = useState(false);
  const [checkSix, setCheckSix] = useState(false);
  const [checkSeven, setCheckSeven] = useState(false);
  const [checkEight, setCheckEight] = useState(false);
  const [checkNine, setCheckNine] = useState(false);
  const [checkTen, setCheckTen] = useState(false);
  const [checkEleven, setCheckEleven] = useState(false);

  const handleScroll = (e: any) => {
    setIsScrolled(
      e.target.scrollHeight - e.target.scrollTop - e.target.offsetHeight <= 0
    );
  };
  const [scroll, setScroll] = useState<any>(null);

  const [isScrolled, setIsScrolled] = useState(false);
  const [checkedAll, setIsCheckedAll] = useState(true);

  const [pdfWidth, setPdfWidth] = useState(Math.round(window.innerWidth * 0.8));
  useEffect(() => {
    const handleResize = () => {
      setPdfWidth(Math.round(window.innerWidth * 0.8));
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (confirmed) {
      setIsScrolled(true);
      setCheckOne(true);
      setCheckTwo(true);
      setCheckThree(true);
      setCheckFour(true);
      setCheckFive(true);
      setCheckSix(true);
      setCheckSeven(true);
      setCheckEight(true);
      setCheckNine(true);
      setCheckTen(true);
      setCheckEleven(true);
    }
  }, [confirmed]);

  useEffect(() => {
    if (
      isScrolled &&
      checkOne &&
      checkTwo &&
      checkThree &&
      checkFour &&
      checkFive &&
      checkSix &&
      checkSeven &&
      checkEight &&
      checkNine &&
      checkTen &&
      checkEleven
    ) {
      setIsCheckedAll(false);
      isRegister(true);
    } else {
      setIsCheckedAll(true);
      isRegister(false);
    }
  }, [
    isScrolled,
    checkOne,
    checkTwo,
    checkThree,
    checkFour,
    checkFive,
    checkSix,
    checkSeven,
    checkEight,
    checkNine,
    checkTen,
    checkEleven,
    isRegister,
    confirmed,
  ]);

  useEffect(() => {
    let currentDom: any = scroll;

    if (currentDom) {
      currentDom!.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (currentDom) {
        currentDom!.removeEventListener("scroll", handleScroll);
      }
    };
  }, [open, scroll]);

  return (
    <Box>
      <TkButton onClick={() => setOpen(true)}>
        重要事項を確認してください
      </TkButton>

      <Modal
        className="SCRC030102components"
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="importantMattersModal">
          <Stack
            direction="row"
            spacing={2}
            pb={2}
            data-testid="tkModalForTest"
          >
            <a
              href={`${
                process.env.PUBLIC_URL ?? ""
              }/assets/pdf/RPT021_重要事項確認書.pdf`}
              download
            >
              <TkButton size="small">重要事項説明書印刷</TkButton>
            </a>
            <TkButton
              size="small"
              onClick={() => {
                window.open(
                  "https://elaws.e-gov.go.jp/document?lawid=336AC0000000155"
                );
              }}
            >
              社会福祉施設職員等退職手当共済法
            </TkButton>
            <TkButton
              size="small"
              onClick={() => {
                window.open(
                  "https://elaws.e-gov.go.jp/document?lawid=336CO0000000286"
                );
              }}
            >
              社会福祉施設職員等退職手当共済法施行令
            </TkButton>
            <TkButton
              size="small"
              onClick={() => {
                window.open(
                  "https://elaws.e-gov.go.jp/document?lawid=336M50000100036"
                );
              }}
            >
              社会福祉施設職員等退職手当共済法施行規則
            </TkButton>
            <TkButton
              size="small"
              onClick={() => {
                window.open(
                  "https://www.wam.go.jp/hp/cat_info_taisyokuteate/guide-taisyokuteate-txt-tabid-239/"
                );
              }}
            >
              社会福祉施設職員等退職手当共済約款
            </TkButton>
          </Stack>
          <Box>
            <Paper
              elevation={0}
              sx={{
                background: "1px",
                overflowY: "scroll",
                overflowX: "hidden",
                height: "500px",
                width: "100%",
                border: 3,
                mb: 1,
              }}
              data-testid="tkModalPaperForTest"
              ref={setScroll}
            >
              <Document
                file={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/RPT021_重要事項確認書.pdf`}
              >
                {Array.from(new Array(8), (_, index) => index + 1).map(
                  (pageNumber) => (
                    <Page
                      key={pageNumber}
                      pageNumber={pageNumber}
                      width={pdfWidth}
                    />
                  )
                )}
              </Document>
            </Paper>
          </Box>

          <Box pt={3}>
            上記１～１１の重要事項について、内容を確認してください。
            <br />
            <u>
              ※最後までスクロールして内容を確認していただいた後、画面下部の同意ボタンを押下できるようになります。
            </u>
            <br />
            <br />
            上記１～１１の重要事項をご理解いただけましたら、☐（チェックボックス）に✔を入れていただき、同意ボタンを押下してください。
          </Box>

          <Box pt={3}>
            <Stack direction={"row"} alignItems={"center"} spacing={2} pt={3}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkOne}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckOne(true);
                  } else {
                    setCheckOne(false);
                  }
                }}
              />
              <Typography>
                法令に基づいて運営されている公的制度であること（重要事項１）
              </Typography>
            </Stack>
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkTwo}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckTwo(true);
                  } else {
                    setCheckTwo(false);
                  }
                }}
              />
              <Typography>
                賦課方式により毎年度掛金を納付すること（重要事項２）
              </Typography>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkThree}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckThree(true);
                  } else {
                    setCheckThree(false);
                  }
                }}
              />
              <Typography>
                退職手当共済契約の申込みができる経営者が限定されていること（重要事項３）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkFour}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckFour(true);
                  } else {
                    setCheckFour(false);
                  }
                }}
              />
              <Typography>
                退職手当共済契約締結時の施設・事業・職員を認識していること（重要事項４）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkFive}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckFive(true);
                  } else {
                    setCheckFive(false);
                  }
                }}
              />
              <Typography>
                ４月１日の被共済職員の重要性（重要事項５）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkSix}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckSix(true);
                  } else {
                    setCheckSix(false);
                  }
                }}
              />
              <Typography>
                本俸月額（俸給表の額・俸給の調整額）の重要性（重要事項６）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkSeven}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckSeven(true);
                  } else {
                    setCheckSeven(false);
                  }
                }}
              />
              <Typography>被共済職員期間について（重要事項７）</Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkEight}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckEight(true);
                  } else {
                    setCheckEight(false);
                  }
                }}
              />
              <Typography>
                共済契約者には様々な義務があること（重要事項８）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkNine}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckNine(true);
                  } else {
                    setCheckNine(false);
                  }
                }}
              />
              <Typography>
                被共済職員期間の通算及び合算について（重要事項９）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkTen}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckTen(true);
                  } else {
                    setCheckTen(false);
                  }
                }}
              />
              <Typography>
                退職手当共済契約解除について（重要事項１０）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Checkbox
                data-testid="tkModalCheckForTest"
                checked={checkEleven}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCheckEleven(true);
                  } else {
                    setCheckEleven(false);
                  }
                }}
              />
              <Typography>
                退職手当共済契約締結日について（重要事項１１）
              </Typography>
              <Stack direction={"row"} alignItems={"center"}></Stack>
            </Stack>

            <Stack
              direction="row"
              spacing={2}
              alignItems={"center"}
              justifyContent={"center"}
              pt={1}
            >
              <TkButton
                onClick={() => {
                  setOpen(false);
                }}
              >
                戻る
              </TkButton>
              <TkButton
                size="small"
                disabled={checkedAll}
                onClick={() => {
                  setOpen(false);
                }}
              >
                同意します
              </TkButton>
            </Stack>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default TkImportantMattersModal;
